<template>
  <div>
    <div class="login_container" v-if="login == true">
      <el-form ref="form" :model="form" class="item_font">
        <el-form-item style="width: 350px; margin-top: 10px"
          ><el-input
            v-model="form.station"
            placeholder="站点ID"
            :disabled="true"
          ></el-input
        ></el-form-item>
        <el-form-item style="width: 350px; margin-top: 10px"
          ><el-input
            v-model="form.name"
            placeholder="账号"
            :disabled="true"
          ></el-input
        ></el-form-item>
        <el-form-item style="width: 350px; margin-top: 10px"
          ><el-input
            v-model="form.passWord"
            placeholder="密码"
            type="password"
            @keyup.enter.native="enterLogin"
          ></el-input
        ></el-form-item>
        <el-form-item
          style="
            width: 350px;
            margin-top: 10px;
            display: flex;
            flex-direction: row-reverse;
          "
        >
          <el-checkbox
            label="10天内免登录"
            name="type"
            v-model="isFreeLogin"
            @change="checkAction"
            v-show="false"
            class="item_font"
          ></el-checkbox>
          <el-button type="text" @click="forgetpassword()" class="item_font"
            >忘记密码？</el-button
          >
        </el-form-item>
        <el-form-item style="width: 350px; margin-top: 10px"
          ><el-button
            type="primary"
            @click="submit"
            style="width: 100%"
            class="item_font"
            >立即登录</el-button
          ></el-form-item
        >
      </el-form>
      <!-- <JwChat-login
        @forgetpassword="forgetpassword($event)"
        @submit="submit"
        :config="{
          rules: {
            username: [
              {
                required: true,
                trigger: 'blur',
                validator: function (rule, value, callback) {
				if (!value) {
                    callback(error('请输入账号'));
                  } else {
                    callback();
                  }
                },
              },
            ],
            password: [
              {
                required: true,
                trigger: 'blur',
                validator: function (rule, value, callback) {
                  if (!value) {
                    callback(error('请输入密码'));
                  } else {
                    callback();
                  }
                },
              },
            ],
          },
        }"
      /> -->
    </div>
    <div v-if="setPassword == true">
      <FGpassword
        @confirm="confirmSet"
        @close="closeSet"
        :userName="form.name"
        :phoneNumber="phoneNumber"
        :code="code"
        @clickCancle="clickCancle"
        :password="password"
      ></FGpassword>
    </div>
    <div v-if="MessageCode == true">
      <MsgCode
        @ReSend="ReSend"
        @successed="successed"
        @close="close"
        :password="passWord"
        :username="userName"
        :equNo="equNo"
        :isFree="isFreeLogin"
      ></MsgCode>
    </div>
  </div>
</template>

<script>
import FGpassword from "../components/ForgetPasswordBox/index.js";
import MsgCode from "../components/MessageCodeBox/index.js";
export default {
  data() {
    return {
      username: true,
      login: true,
      setPassword: false,
      MessageCode: false,
      phoneNumber: "",
      isFreeLogin: false,
      form: {
        name: "",
      },
      userName: "",
      passWord: "",
      equNo: "",
      code: true,
      password: false,
    };
  },
  components: {
    FGpassword,
    MsgCode,
  },

  mounted() {
    console.log("views Login mouted");
    const site = JSON.parse(localStorage.getItem("siteObj"));
    this.form.station = site.webId;
    this.form.name = JSON.parse(localStorage.getItem("username"));

    this.util.setLocalFree("0");
  },

  methods: {
    error(info) {
      console.log("进入error方法", info);
      new Error(info);
    },
    loginAction() {
      this.$router.replace("/home");
    },
    submit() {
      // console.log("Login",this.MessageCode,info)
      console.log("login submit form = ", this.form);
      this.userName = this.form.name;
      //this.MessageCode = true;
      this.passWord = this.form.passWord;
      this.safeFuleCheck();
      //this.getSMScode(this.userName);

      // this.loginAction()
    },
    //安全验证
    async safeFuleCheck() {
      var checkurl = "/manager/equipment/evn/check";
      const response = await this.util.postRequest({
        url: checkurl,
        method: "POST",
        data: {
          loginName: this.userName,
        },
      });
      console.log("Login getSMScode response = ", response);
      if (response.resultCode == 10000) {
        this.equNo = response.data.equNo;
        if (response.data.smsValidate) {
          this.MessageCode = true;
          this.getSMScode(this.userName);
        } else {
          const site = this.util.getLocalSite();
          var loginApi = "/manager/user/pass/login";
          const response = await this.util.postRequest({
            url: loginApi,
            method: "POST",
            data: {
              loginName: this.userName,
              password: this.passWord,
              captcha: "",
              isLogFree: this.isFreeLogin,
              webId: site.webId,
              equNo: this.equNo,
            },
          });
          console.log("messageCodeBox input response = ", response);
          if (response.resultCode === "10000") {
            var account = response.data.bearUser;
            console.log("messageBox id = ", account.id);

            var token = response.data.token;
            localStorage.setItem("token", token);

            localStorage.setItem("account", JSON.stringify(account));
            this.tishi = false;
            this.successed();

            this.util.setLoginTip(1);

            this.getAuthorityRequest();
          } else {
            this.$message.error(response.desc);
          }
        }
      }
    },

    async forgetpassword() {
      console.log("login forgetpassword");
      var api = "/manager/user/pass/getUserTel";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          loginName: this.form.name,
        },
      });
      console.log("request_data：", {
        loginName: this.form.name,
      });
      console.log("index forgetpassword response = ", response);
      if (response.resultCode === "10000") {
        console.log("index forgetpassword response =  成功");
        this.phoneNumber = response.data;
        this.setPassword = true;
        this.code = true;
      } else {
        console.log("index forgetpassword response =  失败");
        this.$message.error(response.desc);
      }
    },
    async getAuthorityRequest() {
      console.log("msgCodeBox getAuthorityRequest");
      var api = "/manager/permission/getPermissionList";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
      });
      console.log("msgCodeBox getAuthorityRequest response =xx ", response);
      if (response.resultCode === "10000") {
        this.setDefaultSetting();
        var tempObj = this.util.getLocalPermintObj();
        for (var i = 0; i < response.data.length; i++) {
          const chatPermi = response.data[i];
          if (chatPermi.name === "对话管理") {
            const permiList = chatPermi.permiVoList;
            for (var j = 0; j < permiList.length; j++) {
              var permit = permiList[j];
              if (permit.name === "关闭会话") {
                tempObj.endChat = permit.status == 1 ? true : false;
              } else if (permit.name === "勿扰设置") {
                tempObj.disturb = permit.status == 1 ? true : false;
              } else if (permit.name === "转接会话") {
                tempObj.transter = permit.status == 1 ? true : false;
              } else if (permit.name === "打标签") {
                tempObj.markTag = permit.status == 1 ? true : false;
              } else if (permit.name === "添加黑名单") {
                tempObj.defriend = permit.status == 1 ? true : false;
              } else if (permit.name === "接管会话") {
                tempObj.adapter = permit.status == 1 ? true : false;
              } else if (permit.name === "我的同事") {
                tempObj.colleage = permit.status == 1 ? true : false;
              } else if (permit.name === "疑似骚扰用户") {
                tempObj.trouble = permit.status == 1 ? true : false;
              } else if (permit.name === "转接给他人") {
                tempObj.transterTa = permit.status == 1 ? true : false;
              } else if (permit.name == "在线访客列表") {
                tempObj.isOnlineList = permit.status == 1 ? true : false;
              }else if (permit.name == "同事快捷回复展现") {
                tempObj.quickShow = permit.status == 1 ? true : false;
              }else if (permit.name == "公共快捷回复展现") {
                tempObj.publicQuickShow = permit.status == 1 ? true : false;
              }else if (permit.name == "已离开（未结束）列表") {
                tempObj.isOnlineOffList = permit.status == 1 ? true : false;
              }
            }
          } else if (chatPermi.name === "个人设置") {
            console.log("个人设置。。。。", chatPermi.permiVoList);
            console.log("个人设置。。。。", chatPermi.permiVoList);
            tempObj.personPmtList = chatPermi.permiVoList.sort(function (a, b) {
              return a.orderNum - b.orderNum;
            });
            console.log("tempObj.personPmtList:", tempObj.personPmtList);
          } else if (chatPermi.name === "系统设置") {
            tempObj.systemPmtList = this.util.normalizeSystemPmtList(
              chatPermi.permiVoList
            );
          } else if (chatPermi.name === "日志管理") {
            tempObj.log = chatPermi.status == 1 ? true : false;
          } else if (chatPermi.name === "留言管理") {
            tempObj.word = chatPermi.status == 1 ? true : false;
          } else if (chatPermi.name === "对话记录") {
            tempObj.record = chatPermi.status == 1 ? true : false;
          } else if (chatPermi.name === "开口机器人") {
            tempObj.bot = chatPermi.status == 1 ? true : false;
          } else if (chatPermi.name === "报表管理") {
            const permiList = chatPermi.permiVoList;
            for (var o = 0; o < permiList.length; o++) {
              var permit1 = permiList[o];
              if (permit1.name === "HTML报表下载") {
                tempObj.downHtml = permit1.status == 1 ? true : false;
              }
            }
          } else if (chatPermi.name === "Middleman管理") {
            tempObj.midmanPmtList = chatPermi.permiVoList.sort(function (a, b) {
              return a.orderNum - b.orderNum;
            });
          } else if (chatPermi.name === "登录管理") {
            tempObj.loginmgList = chatPermi.permiVoList.sort(function (a, b) {
              return a.orderNum - b.orderNum;
            });
          }
        }

        this.util.setLocalPermit(JSON.stringify(tempObj));

        this.$store.state.authority.isShowLog = this.util.getLocalPermit("log");
        this.$store.state.authority.isShowWord =
          this.util.getLocalPermit("word");
        this.$store.state.authority.isColleague =
          this.util.getLocalPermit("colleage");
        this.$store.state.authority.isTrouble =
          this.util.getLocalPermit("trouble");
        this.$store.state.authority.isEndChat =
          this.util.getLocalPermit("endChat");
        this.$store.state.authority.isTransfer =
          this.util.getLocalPermit("transter");
        this.$store.state.authority.isDefriend =
          this.util.getLocalPermit("defriend");
        this.$store.state.authority.isAdapter =
          this.util.getLocalPermit("adapter");
        this.$store.state.authority.isDisturb =
          this.util.getLocalPermit("disturb");
        this.$store.state.authority.isMarkTag =
          this.util.getLocalPermit("markTag");
        this.$store.state.authority.isShowBot = this.util.getLocalPermit("bot");
        this.$store.state.authority.isShowRecord =
          this.util.getLocalPermit("record");
        this.$store.state.authority.isOnlineList =
          this.util.getLocalPermit("isOnlineList");
        this.$store.state.authority.isOnlineOffList =
          this.util.getLocalPermit("isOnlineOffList");
        this.$store.state.authority.isTransferTa =
          this.util.getLocalPermit("transterTa");
        this.$store.state.authority.isDownHtml =
          this.util.getLocalPermit("downHtml");
        this.$store.state.authority.personList =
          this.util.getLocalPermit("personPmtList");
        this.$store.state.authority.systemList =
          this.util.getLocalPermit("systemPmtList");
        this.$store.state.authority.midmanList =
          this.util.getLocalPermit("midmanPmtList");
        this.$store.state.authority.loginmg =
          this.util.getLocalPermit("loginmgList");
          this.$store.state.authority.isQuickShow =
          this.util.getLocalPermit("quickShow");
          this.$store.state.authority.isPublicQuickShow =
          this.util.getLocalPermit("publicQuickShow");
      } else {
        this.$message.error(response.desc);
      }
    },
    close() {
      this.MessageCode = false;
    },
    confirmSet(info) {
      console.log("login confirmSet info = ", info);
      if (info == 1) {
        console.log("传递第1次确定");
      } else if (info == 2) {
        console.log("传递第2次确定");
      } else {
        console.log("传递第3次确定");
        this.setPassword = false;
      }
    },
    closeSet() {
      this.setPassword = false;
    },
    next() {
      this.login = true;
      this.username = false;
    },

    ReSend() {},

    successed() {
      // const tipMsg = '登录成功'
      // this.$message({
      // 	message:tipMsg,
      // 	type:'success'
      // })
      this.$router.push({
        path: "/home",
      });
    },
    async getSMScode(name) {
      console.log("login getSMScode name = ", name);
      var loginApi = "/manager/user/pass/newUserSMS";
      const response = await this.util.postRequest({
        url: loginApi,
        method: "POST",
        data: {
          loginName: name,
        },
      });
      console.log("Login getSMScode response = ", response);
    },

    checkAction(newVal) {
      console.log("Login checkAction newVal = ", newVal);
      if (newVal === true) {
        this.util.setLocalFree(1);
      } else {
        this.util.setLocalFree(0);
      }
    },
    enterLogin(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      console.log("input框webid", keyCode, e);
      if (keyCode == 13) {
        this.submit();
      }
    },
    clickCancle(info) {
      console.log("clickCancle==info", info);
      if (info.type === "code") {
        this.code = info.value;
      } else if (info.type === "password") {
        this.password = info.value;
      }
    },
    setDefaultSetting() {
      console.log("msgCodeBox setDefaultSetting");
      var tempObj = {};
      tempObj.endChat = false;
      tempObj.disturb = false;
      tempObj.transter = false;
      tempObj.markTag = false;
      tempObj.defriend = false;
      tempObj.adapter = false;
      tempObj.colleage = false;
      tempObj.trouble = false;
      tempObj.personPmtList = [];
      tempObj.systemPmtList = [];
      // tempObj.systemPmtList = []
      tempObj.log = false;
      tempObj.word = false;
      tempObj.record = false;
      tempObj.bot = false;
      tempObj.transterTa = false;
      tempObj.downHtml = false;
      tempObj.quickShow = false;
      tempObj.publicQuickShow = false;
      this.util.setLocalPermit(JSON.stringify(tempObj));
    },
  },
};
</script>

<style>
.login_container {
  width: 40vw;
  height: 45vh;
  min-width: 500px;
  background: #ffffff;
  box-shadow: 0px 0px 7px 5px rgba(230, 230, 230, 0.5);
  border-radius: 20px;
  /* margin: 0 auto; */
  margin-top: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 30vw;
}
</style>
